import { AppShell } from "@climatepartner/app-shell";
import { Toast } from "@climatepartner/components/Toast";
import { Typography } from "@mui/material";
import { Outlet, useLocation, useParams } from "react-router-dom";

import { useOrganisationName } from "../../shared/auth/use-organisation";
import { UserProvider } from "../../shared/auth/user-provider";
import { ENVIRONMENT } from "../../shared/config/environment";
import { featureFlagsConfig } from "../../shared/feature-flags/feature-flags-config";
import { GlobalMaintenanceModeProvider } from "../../shared/maintenance/maintenance-mode-provider";
import { monitoringConfig } from "../../shared/monitoring/monitoring-config";
import { ViewedAccountTracker } from "../../shared/monitoring/viewed-account-tracker";
import { BreadcrumbsProvider } from "../../shared/ui/layout/breadcrumbs";
import { themePalette } from "../../shared/ui/theme-palette";
import { getCurrentServiceId } from "../routes/current-service-id";
import { RouteMemory } from "../routes/route-memory";
import { DeprecatedDomainWarning } from "./deprecated-domain-warning";
import { InterruptedChangeNotice } from "./interrupted-change-notice";

export const AppLayout = () => {
  const env = process.env.NODE_ENV === "production" ? "prod" : "dev";
  const { customerId } = useParams();
  const organizationName = useOrganisationName(customerId);
  const { pathname } = useLocation();
  const serviceId = getCurrentServiceId(pathname);

  return (
    <AppShell
      theme={themePalette}
      fronteggEnvironment={ENVIRONMENT}
      currentServiceId={serviceId}
      config={{
        localize: {
          serviceId,
          env: env,
        },
        monitoring: monitoringConfig,
        featureFlags: featureFlagsConfig,
      }}
      header={{ slots: { middle: <Typography sx={{ mx: 2 }}> {organizationName} </Typography> } }}
    >
      <UserProvider>
        <GlobalMaintenanceModeProvider>
          <ViewedAccountTracker />
          <BreadcrumbsProvider>
            <DeprecatedDomainWarning />
            <RouteMemory>
              <Outlet />
            </RouteMemory>
          </BreadcrumbsProvider>
        </GlobalMaintenanceModeProvider>
      </UserProvider>
      <Toast />
      <InterruptedChangeNotice />
    </AppShell>
  );
};
